"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToggleStyles = exports.toggleVars = exports.toggleCommonProps = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var toggleCommonProps = exports.toggleCommonProps = _commonProps.defaultCommonProps;
var toggleVars = exports.toggleVars = (0, _initVars.default)({
  applied: toggleCommonProps,
  variables: [{
    key: "rootAlign"
  }, {
    key: "checkboxColor",
    canHaveColor: true
  }, {
    key: "rootBackground",
    canHaveColor: true
  }]
});
var styles = function styles(theme) {
  var controlWidth = 34;
  var toggleWidth = 20;
  return {
    variables: toggleVars.styles,
    root: {
      flexShrink: 0,
      display: "inline-flex",
      alignItems: toggleVars.get("rootAlign"),
      verticalAlign: "middle",
      position: "relative",
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.fontSize,
      color: theme.colors.baseContrast070
    },
    checkbox: {
      opacity: 0,
      width: "100%",
      height: "100%",
      position: "absolute",
      margin: 0,
      zIndex: 1,
      cursor: "pointer",
      "&:checked ~ $button:after": {
        insetInlineStart: 15
      },
      /**
       * The next selector is because the :disabled and :checked selectors have the same specificity
       * This allows the disabled state colors to override the checked state colors
       */
      "&:checked:not(:disabled)": {
        "& ~ $button": {
          "&::after": {
            backgroundColor: toggleVars.get("checkboxColor") // On toggle color
          }
        }
      },
      "&:disabled": {
        cursor: "not-allowed",
        "& ~ $button": {
          cursor: "not-allowed",
          backgroundColor: theme.colors.baseContrast030,
          // Disabled background color
          "&:after": {
            backgroundColor: theme.colors.baseContrast040 // Disabled toggle color
          }
        },
        "& ~ $label": {
          fontFamily: "inherit",
          color: theme.colors.baseContrast040
        }
      }
    },
    button: {
      transition: "all 0.3s ease",
      backgroundColor: theme.colors.baseContrast030,
      // Off background color
      borderRadius: toggleWidth,
      position: "relative",
      width: controlWidth,
      minWidth: controlWidth,
      height: controlWidth - toggleWidth,
      "&:after": {
        backgroundColor: theme.colors.baseContrast070,
        // Off toggle color
        boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12)",
        position: "relative",
        display: "block",
        width: toggleWidth,
        height: toggleWidth,
        // eslint-disable-next-line @atg/css-rtl-support
        left: 0,
        top: -3,
        content: '""',
        borderRadius: "50%",
        transition: "all 0.2s ease"
      }
    },
    label: {
      color: theme.colors.baseContrast090,
      userSelect: "none",
      margin: "auto",
      marginInlineStart: theme.spacing.base
    },
    hint: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    description: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    }
  };
};
var useToggleStyles = exports.useToggleStyles = (0, _createUseStyles.default)(styles, {
  name: "Toggle"
});